import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

export function useListarTiposAtendimentos() {
  const fetchData = async () => {
    const LISTAR_TIPOS_ATENDIMENTOS = `${leadsWebEnviroment}/app-web/tipos-atendimentos/v1`;
    const response = await instance.get(LISTAR_TIPOS_ATENDIMENTOS);
    const dataWithPagination = {
      data: response?.data?.data,
      pagination: response?.data?.pagination,
    };
    return dataWithPagination;
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    refetchOnWindowFocus: false,
    queryKey: ["listar_tipos_atendimentos"],
    refetchOnMount: false,
  });
  return query;
}
